module.exports = __webpack_public_path__ + "img/10.0b13d81b.png";